import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translationHelpers';
import './InstallSheets.css';

export interface IOSInstallPromptProps {
  show: boolean;
  onDismiss: () => void;
}

function recordInstallDismissed() {
  localStorage.setItem('installPromptDismissed', Date.now().toString());
}

export const IOSInstallPrompt: React.FC<IOSInstallPromptProps> = ({
  show,
  onDismiss,
}) => {
  const { t_nested, currentLanguage } = useLanguage();
  const isRtl = currentLanguage === 'ar';

  const handleDismiss = () => {
    recordInstallDismissed();
    onDismiss();
  };

  if (!show) {
    return null;
  }

  return (
    <>
      <div
        className="ios-install-backdrop"
        onClick={handleDismiss}
        aria-hidden="true"
      />
      <div
        className="ios-install-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ios-install-title"
        dir={isRtl ? 'rtl' : 'ltr'}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="install-sheet-body">
          <div className="install-sheet-header">
            <h2 className="install-sheet-title" id="ios-install-title">
              {t_nested('install.title')}
            </h2>
            <button
              type="button"
              className="install-sheet-close"
              onClick={handleDismiss}
              aria-label={getTranslation(
                t_nested,
                'install.close',
                'Close'
              )}
            >
              ×
            </button>
          </div>
          <div className="install-sheet-content-inner">
            <img
              src="/icons/icon-192x192.png"
              alt=""
              className="install-sheet-icon"
            />
            <p className="install-sheet-message">
              {t_nested('install.mobileMessage')}
            </p>
          </div>
          <div className="install-sheet-actions">
            <button
              type="button"
              className="install-sheet-btn install-sheet-btn-primary"
              onClick={handleDismiss}
            >
              {t_nested('install.iosPrimary')}
            </button>
            <button
              type="button"
              className="install-sheet-btn install-sheet-btn-secondary"
              onClick={handleDismiss}
            >
              {t_nested('install.maybeLater')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
